/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns;

  ns = window.nspace("ccc.profileSelection");

  /**
   * Renders the display of the location type dropdowns and location buttons.
   */
  ns.IndicatorSelectionButtonsView = Backbone.View.extend({
    initialize: function(options) {
      _.bindAll(this);

      // Re-render on model changes
      this.model.once("change", this.render);
      this.model.on("change:location", this.render);
    },

    events: {
      "click .location-type-link": "toggleLocations",
      "click button": "setLocation"
    },

    /**
     * Toggles the display state of the location type dropdowns.
     */
    toggleLocations: function(e) {
      var $self;

      e.preventDefault();

      $self = $(e.currentTarget);

      if ($self.hasClass("active")) {
        this.hideLocations($self);
        return;
      }

      this.showLocations($self);

      // Tracks clicks on location expansion (City, Boroughs, Community Districts, etc) on the "Location Profile" page
      dataLayer.push({
        event: "LP Location Expansion",
        eventCategory: "Interactive Clicks",
        eventAction: "Location Expansion|" + $self.text().trim(),
        eventLabel: window.location.pathname
      });
    },
    hideLocations: function($el) {
      $el
        .next()
        .stop(true, true)
        .slideUp(Math.min(700, 1.1 * $el.next().height()));
      $el.removeClass("active");
    },
    showLocations: function($el) {
      $el
        .next()
        .stop(true, true)
        .slideDown(Math.min(700, 1.1 * $el.next().height()));
      $el.addClass("active");
    },

    /**
     * Sets the model's location in response to a DOM event.
     */
    setLocation: function(e) {
      var $self;

      $self = $(e.currentTarget);
      this.model.set({
        location: $self.data("loc-id"),
        locationType: $self.data("loctype-id"),
        locationSlug: $self.data("loc-slug")
      });

      // Tracks clicks on a location (Ex: University Heights (B05)) on the "Create Location Profiles" page
      dataLayer.push({
        event: "LP Location Selection",
        eventCategory: "Interactive Clicks",
        eventAction: "Location Selection|" + $self.text().trim(),
        eventLabel: window.location.pathname
      });
    },

    /**
     * A controlling method that renders everything relevant to this view's context.
     */
    render: function() {
      this.renderLocation();
    },

    /**
     * Renders the location buttons according to the model state.
     */
    renderLocation: function() {
      var $button, $toggleButton;

      if (!this.model.get("location")) {
        return;
      }

      this.$("button,li").removeClass("active");
      $button = this.$(
        "button[data-loc-id=" + this.model.get("location") + "]"
      ).addClass("active");
      $button.parent().addClass("active");

      // Make sure that the current location's list is expanded.
      $toggleButton = $button.parents("div:first").prev();
      if ($toggleButton.hasClass("active")) {
        return;
      }

      this.showLocations($toggleButton);
    }
  });
})(jQuery, _);
